<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="container-fluid">
  <h6  class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/admin/overview"> Home </router-link><span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Customer<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>CRM Notes<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/crm/index"> Manage CRM Note </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> View CRM  </h6>



 



<div class="card mt-1">
<div class="card-body">


    <table style="font-size: small; " class="table table-striped table-sm table-hover ">
       
          <tbody>

            <tr>
              <td class="width-custom2"><b>Id </b></td>
             <td>{{ crms.idServicelog}}</td> 
            </tr>
            <tr>
              <td><b>Name of Homeowner</b></td>
             <td>{{crms.C_name}}</td> 
            </tr>
           
           
            <tr>
              <td><b>Comments</b></td>
             <td>{{crms.comments }}</td> 
            </tr>
            
            <tr>
              <td><b>Created Date</b></td>
             <td>{{ crms.created_date}}</td> 
            </tr>
            <tr>
              <td><b>Added By </b></td>
             <td>{{crms.username }}</td> 
            </tr>
            <tr>
              <td><b>Follow up Date </b></td>
             <td>{{crms.followup_date }}</td> 
            </tr>
            <tr>
              <td><b>Follow up By </b></td>
             <td>{{crms.followup_by }}</td> 
            </tr>
           
             
          </tbody>


        </table>
       




   
    

    




</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
       
        'idServicelog':this.$route.query.id,
        
        crms:{},
      
       
      


        
      }

    },
    mounted(){
 
  this.loadCrm();
    },

    computed: {
    roundToTwoDecimal() {
      return detail => parseFloat(detail).toFixed(2);
    }
  },
methods : {

  

      


  
  
  async loadCrm() {
   
    try {
      const { data} = await  axios.get('/mservicelog/view?id='+this.idServicelog,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.crms = data.crm;
       
      
    } catch (error) {
      console.log(error.response);
    }
  },




},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style >

</style>